// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host .container {
  display: flex;
  flex-direction: column;
  min-width: 300px;
  position: absolute;
  bottom: 0px;
  top: 1px;
  left: 0px;
  right: 0px;
}
:host .filter {
  display: inline-block;
  min-height: 50px;
  padding: 8px 24px 0;
}
:host .filter .mat-form-field {
  font-size: 14px;
  width: 100%;
}
:host .mat-table {
  overflow: auto;
  /* min-width: 1500px; */
  height: 100%;
}
:host .mat-row {
  min-height: 40px;
  height: 43px;
}
:host .mat-cell {
  font-size: 13px;
}
:host .mat-header-row {
  top: 0;
  position: sticky;
  z-index: 1;
}
:host .mat-header-cell {
  font-size: 15px;
}
:host .mat-column-select {
  overflow: visible;
  flex: 0 0 80px;
}
:host .mat-column-name {
  flex: 1 1 200px;
}
:host .mat-column-address {
  flex: 2 1 280px;
}
:host .mat-column-device {
  flex: 1 1 140px;
}
:host .mat-column-type {
  flex: 0 0 120px;
}
:host .mat-column-value {
  flex: 1 1 180px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-right: 10px;
}
:host .mat-column-timestamp {
  flex: 0 0 140px;
}
:host .mat-column-description {
  flex: 1 1 140px;
}
:host .mat-column-logger {
  flex: 0 0 80px;
  font-size: 10px;
}
:host .mat-column-logger mat-icon {
  font-size: 20px;
  height: 20px;
}
:host .mat-column-info {
  flex: 0 0 40px;
}
:host .mat-column-warning {
  flex: 0 0 30px;
}
:host .mat-column-options {
  flex: 0 0 60px;
}
:host .mat-column-min {
  flex: 0 0 100px;
}
:host .mat-column-max {
  flex: 0 0 100px;
}
:host .mat-column-remove {
  flex: 0 0 60px;
}
:host .mat-column-direction {
  flex: 0 0 120px;
}
:host .selectidthClass {
  flex: 0 0 50px;
}
:host .warning {
  color: red;
}
:host .my-header-filter ::ng-deep .mat-sort-header-button {
  display: block;
  text-align: left;
  margin-top: 5px;
}
:host .my-header-filter ::ng-deep .mat-sort-header-arrow {
  top: -12px;
  right: 20px;
}
:host .my-header-filter-input {
  display: block;
  margin-top: 4px;
  margin-bottom: 6px;
  padding: 3px 1px 3px 2px;
  border-radius: 2px;
}
:host .context-menu {
  font-size: 13px;
}`, "",{"version":3,"sources":["webpack://./src/app/device/device-list/device-list.component.scss","webpack://./../../../../%E6%9D%AD%E5%B7%9E%E6%95%B0%E7%BA%B3%E5%B7%9D/IccpPlatform/fuxa/client/src/app/device/device-list/device-list.component.scss"],"names":[],"mappings":"AACI;EACI,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;ACAR;ADGI;EACI,qBAAA;EACA,gBAAA;EACA,mBAAA;ACDR;ADII;EACI,eAAA;EACA,WAAA;ACFR;ADKI;EACI,cAAA;EACA,uBAAA;EACA,YAAA;ACHR;ADMI;EACI,gBAAA;EACA,YAAA;ACJR;ADOI;EACI,eAAA;ACLR;ADQI;EACI,MAAA;EACA,gBAAA;EACA,UAAA;ACNR;ADSI;EACI,eAAA;ACPR;ADUI;EACI,iBAAA;EACA,cAAA;ACRR;ADWI;EACI,eAAA;ACTR;ADaI;EACI,eAAA;ACXR;ADcI;EACI,eAAA;ACZR;ADeI;EACI,eAAA;ACbR;ADgBI;EACI,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;ACdR;ADiBI;EACI,eAAA;ACfR;ADkBI;EACI,eAAA;AChBR;ADmBI;EACI,cAAA;EACA,eAAA;ACjBR;ADoBI;EACI,eAAA;EACA,YAAA;AClBR;ADqBI;EACI,cAAA;ACnBR;ADsBI;EACI,cAAA;ACpBR;ADuBI;EACI,cAAA;ACrBR;ADwBI;EACI,eAAA;ACtBR;ADyBI;EACI,eAAA;ACvBR;AD0BI;EACI,cAAA;ACxBR;AD2BI;EACI,eAAA;ACzBR;AD4BI;EACI,cAAA;AC1BR;AD6BI;EACI,UAAA;AC3BR;AD8BI;EACI,cAAA;EACA,gBAAA;EACA,eAAA;AC5BR;AD+BI;EACI,UAAA;EACA,WAAA;AC7BR;ADgCI;EACI,cAAA;EACA,eAAA;EACA,kBAAA;EACA,wBAAA;EACA,kBAAA;AC9BR;ADiCI;EACI,eAAA;AC/BR","sourcesContent":[":host {\n    .container {\n        display: flex;\n        flex-direction: column;\n        min-width: 300px;\n        position: absolute;\n        bottom: 0px;\n        top: 1px;\n        left:0px;\n        right:0px;\n    }\n\n    .filter {\n        display: inline-block;\n        min-height: 50px;\n        padding: 8px 24px 0;\n    }\n\n    .filter .mat-form-field {\n        font-size: 14px;\n        width: 100%;\n    }\n\n    .mat-table {\n        overflow: auto;\n        /* min-width: 1500px; */\n        height: 100%;\n    }\n\n    .mat-row {\n        min-height: 40px;\n        height: 43px;\n    }\n\n    .mat-cell {\n        font-size: 13px;\n    }\n\n    .mat-header-row {\n        top: 0;\n        position: sticky;\n        z-index: 1;\n    }\n\n    .mat-header-cell {\n        font-size: 15px;\n    }\n\n    .mat-column-select {\n        overflow: visible;\n        flex: 0 0 80px;\n    }\n\n    .mat-column-name {\n        flex: 1 1 200px;\n    }\n\n\n    .mat-column-address {\n        flex: 2 1 280px;\n    }\n\n    .mat-column-device {\n        flex: 1 1 140px;\n    }\n\n    .mat-column-type {\n        flex: 0 0 120px;\n    }\n\n    .mat-column-value {\n        flex: 1 1 180px;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        margin-right: 10px;\n    }\n\n    .mat-column-timestamp {\n        flex: 0 0 140px;\n    }\n\n    .mat-column-description {\n        flex: 1 1 140px;\n    }\n\n    .mat-column-logger {\n        flex: 0 0 80px;\n        font-size: 10px;\n    }\n\n    .mat-column-logger mat-icon {\n        font-size: 20px;\n        height: 20px;\n    }\n\n    .mat-column-info {\n        flex: 0 0 40px;\n    }\n\n    .mat-column-warning {\n        flex: 0 0 30px;\n    }\n\n    .mat-column-options {\n        flex: 0 0 60px;\n    }\n\n    .mat-column-min {\n        flex: 0 0 100px;\n    }\n\n    .mat-column-max {\n        flex: 0 0 100px;\n    }\n\n    .mat-column-remove {\n        flex: 0 0 60px;\n    }\n\n    .mat-column-direction {\n        flex: 0 0 120px;\n    }\n\n    .selectidthClass{\n        flex: 0 0 50px;\n    }\n\n    .warning {\n        color: red;\n    }\n\n    .my-header-filter ::ng-deep .mat-sort-header-button {\n        display: block;\n        text-align: left;\n        margin-top: 5px;\n    }\n\n    .my-header-filter ::ng-deep .mat-sort-header-arrow {\n        top: -12px;\n        right: 20px;\n    }\n\n    .my-header-filter-input {\n        display: block;\n        margin-top: 4px;\n        margin-bottom: 6px;\n        padding: 3px 1px 3px 2px;\n        border-radius: 2px;\n    }\n\n    .context-menu {\n        font-size: 13px;\n    }\n}\n",":host .container {\n  display: flex;\n  flex-direction: column;\n  min-width: 300px;\n  position: absolute;\n  bottom: 0px;\n  top: 1px;\n  left: 0px;\n  right: 0px;\n}\n:host .filter {\n  display: inline-block;\n  min-height: 50px;\n  padding: 8px 24px 0;\n}\n:host .filter .mat-form-field {\n  font-size: 14px;\n  width: 100%;\n}\n:host .mat-table {\n  overflow: auto;\n  /* min-width: 1500px; */\n  height: 100%;\n}\n:host .mat-row {\n  min-height: 40px;\n  height: 43px;\n}\n:host .mat-cell {\n  font-size: 13px;\n}\n:host .mat-header-row {\n  top: 0;\n  position: sticky;\n  z-index: 1;\n}\n:host .mat-header-cell {\n  font-size: 15px;\n}\n:host .mat-column-select {\n  overflow: visible;\n  flex: 0 0 80px;\n}\n:host .mat-column-name {\n  flex: 1 1 200px;\n}\n:host .mat-column-address {\n  flex: 2 1 280px;\n}\n:host .mat-column-device {\n  flex: 1 1 140px;\n}\n:host .mat-column-type {\n  flex: 0 0 120px;\n}\n:host .mat-column-value {\n  flex: 1 1 180px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  margin-right: 10px;\n}\n:host .mat-column-timestamp {\n  flex: 0 0 140px;\n}\n:host .mat-column-description {\n  flex: 1 1 140px;\n}\n:host .mat-column-logger {\n  flex: 0 0 80px;\n  font-size: 10px;\n}\n:host .mat-column-logger mat-icon {\n  font-size: 20px;\n  height: 20px;\n}\n:host .mat-column-info {\n  flex: 0 0 40px;\n}\n:host .mat-column-warning {\n  flex: 0 0 30px;\n}\n:host .mat-column-options {\n  flex: 0 0 60px;\n}\n:host .mat-column-min {\n  flex: 0 0 100px;\n}\n:host .mat-column-max {\n  flex: 0 0 100px;\n}\n:host .mat-column-remove {\n  flex: 0 0 60px;\n}\n:host .mat-column-direction {\n  flex: 0 0 120px;\n}\n:host .selectidthClass {\n  flex: 0 0 50px;\n}\n:host .warning {\n  color: red;\n}\n:host .my-header-filter ::ng-deep .mat-sort-header-button {\n  display: block;\n  text-align: left;\n  margin-top: 5px;\n}\n:host .my-header-filter ::ng-deep .mat-sort-header-arrow {\n  top: -12px;\n  right: 20px;\n}\n:host .my-header-filter-input {\n  display: block;\n  margin-top: 4px;\n  margin-bottom: 6px;\n  padding: 3px 1px 3px 2px;\n  border-radius: 2px;\n}\n:host .context-menu {\n  font-size: 13px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
